/**
 * Utility functions for formatting dates and times according to explicit user timezone and locale preferences,
 * bypassing browser default locales (such as Chrome defaulting to US format).
 */

export const getUserTimezone = () => {
  return localStorage.getItem('timezone') || 'UTC';
};

export const getUserLocale = () => {
  return localStorage.getItem('localePreference') || 'en-GB';
};

export const formatDate = (dateInput, options = {}) => {
  if (!dateInput) return '';
  try {
    const date = typeof dateInput === 'string' || typeof dateInput === 'number' ? new Date(dateInput) : dateInput;
    return new Intl.DateTimeFormat(getUserLocale(), {
      timeZone: getUserTimezone(),
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      ...options,
    }).format(date);
  } catch (e) {
    console.error('Error formatting date:', e);
    return String(dateInput);
  }
};

export const formatDateTime = (dateInput, options = {}) => {
  if (!dateInput) return '';
  try {
    const date = typeof dateInput === 'string' || typeof dateInput === 'number' ? new Date(dateInput) : dateInput;
    return new Intl.DateTimeFormat(getUserLocale(), {
      timeZone: getUserTimezone(),
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      ...options,
    }).format(date);
  } catch (e) {
    console.error('Error formatting datetime:', e);
    return String(dateInput);
  }
};

export const formatTime = (dateInput, options = {}) => {
  if (!dateInput) return '';
  try {
    const date = typeof dateInput === 'string' || typeof dateInput === 'number' ? new Date(dateInput) : dateInput;
    return new Intl.DateTimeFormat(getUserLocale(), {
      timeZone: getUserTimezone(),
      hour: '2-digit',
      minute: '2-digit',
      ...options,
    }).format(date);
  } catch (e) {
    console.error('Error formatting time:', e);
    return String(dateInput);
  }
};

export const toDayLabelWithLocale = (isoDate) => {
  if (!isoDate) return '';
  try {
    const d = new Date(isoDate + 'T00:00:00');
    return new Intl.DateTimeFormat(getUserLocale(), {
      timeZone: getUserTimezone(),
      weekday: 'short',
      day: 'numeric',
    }).format(d);
  } catch (e) {
    console.error('Error in toDayLabelWithLocale:', e);
    return isoDate;
  }
};
